import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraMetricStrip } from '../captains/metric-strip';
/** Overview layout with header, KPI region, work column, and briefing rail. */ export const SpecraDashboardPage = /*#__PURE__*/ React.forwardRef(({ children, className, header, metrics, rail, ...props }, ref)=>/*#__PURE__*/ _jsxs("div", {
        className: cn(// The rail column exists only when there is a rail; otherwise the work
        // column takes the full width.
        'grid min-h-full', rail && 'lg:grid-cols-[minmax(0,1fr)_var(--component-briefing-rail-width)]', className),
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 space-y-5 p-4 sm:space-y-6 sm:p-6",
                children: [
                    header,
                    metrics ? /*#__PURE__*/ _jsx(SpecraMetricStrip, {
                        ...metrics
                    }) : null,
                    children
                ]
            }),
            rail ? /*#__PURE__*/ _jsx("aside", {
                className: "border-t border-border bg-background lg:border-l lg:border-t-0",
                children: rail
            }) : null
        ]
    }));
SpecraDashboardPage.displayName = 'SpecraDashboardPage';
